import './App.css';
// import { useConnect } from 'wagmi'
// import { injected } from 'wagmi/connectors'


import { BrowserRouter, Routes, Route, useParams } from "react-router";

import { useEffect, useState } from 'react'
import { useAccount } from 'wagmi';


import loading_gif from './component/images/loading_gif.gif';

import Alert from './component/Alert';
import CoreUnity_Before_Login from './component/CoreUnity_Before_Login';
import CoreUnity_After_Login from './component/CoreUnity_After_Login';

import {Login_Detail, Refferal_Detail, Refferal_SignUp} from './component/Data_Structure';


import { useConnect } from 'wagmi'
import { injected } from 'wagmi/connectors'


// let url = "https://coreyards.space/";
let url = "https://coreunity.space/";
// let url = "http://localhost:3000/";

let direct_login = false;
// let direct_login = true;

//---------------------------Modal_Area---------------------------------------------------

function LoadingModal(props) {

  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "scroll";
    }
  }, []);
  return (
    <>     
      <div className='modal-wrapper' style={{zIndex: 100}}></div>
        {/*<div className='fixed-top'>
            <div style={{ZIndex: 9, height: '56px', backgroundColor: 'rgba(189, 189, 189, 0.9)'}}></div>
        </div>*/}
      {
        props.isLoading === true ? (
          <>
            <div className='modal-container' style={{zIndex: 101}}>
              <table style={{width: '100%'}}>
                <tbody>
                  <tr>
                    <td style={{width: '100%'}}>
                      
                      <img style={{width: '80px', height: '80px'}} src={loading_gif} alt="loading" />
                          
                    </td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <></>
        )
      }
    </>
  );
}


function Main_Component(props) {

  const { connect } = useConnect();
  const { address } = useAccount();

  const [Login_Try_Count, SetLogin_Try_Count] = useState(Number(0));
  const [IsLogin, SetIsLogin] = useState(false);
  
  const [LoadingModal_Show, SetLoadingModal_Show] = useState(false);
  const [LoadingModal_isLoading, SetLoadingModal_IsLoading] = useState(true);

  const SetLoadingModal = async(istrue, isloading) => {
    SetLoadingModal_Show(istrue);
    SetLoadingModal_IsLoading(isloading);
  }

  const SignIn_Click = async() => {
    if (direct_login === false) {
      connect({ connector: injected() });
    }
    else if (direct_login === true) {
      SetIsLogin(true);
    }
  }
  const SignUp_Click = async() => {
    let ref = "589864235";
    // let R_Num = Math.floor(Math.random() * 2) + 1;
    // // console.log(R_Num);
    // let ref;
    // if(Number(R_Num) === Number(1)) {
    //   ref = "77167883";
    //   console.log("ref Is : " + ref);
    //   window.location.replace(url + "r/" + ref);
    // }
    // else if(Number(R_Num) === Number(2)) {
    //   ref = "86968523";
    //   console.log("ref Is : " + ref);
    //   window.location.replace(url + "r/" + ref);
    // }
    window.location.replace(url + "r/" + ref);
  }

  useEffect(() => {
    const Check_Address = async() => {

      if (address === undefined || address === "" || address === " ") {
        SetIsLogin(false);
      }
      else {
        // SetIsLogin(true);
        props.showAlert("SuccessFully Logined!...", "success", true);

        Login_Detail(address, SetIsLogin, props.showAlert);
      }
      
      // if (Number(Login_Try_Count) === Number(0)) {
        // SetLogin_Try_Count(Number(1));
      // }
      // else if (Number(Login_Try_Count) === Number(1)) {
      //   SetLogin_Try_Count(Number(2));
      // }
      // else if (Number(Login_Try_Count) === Number(2)) {
      //   SetLogin_Try_Count(Number(2));
      // }
    }
    Check_Address();
  }, [address]);


  return (
    <>
      {
        IsLogin === false ? (
          <>
            <CoreUnity_Before_Login SignIn_Click={SignIn_Click} SignUp_Click={SignUp_Click} showAlert={props.showAlert}/>
          </>
        ) : IsLogin === true ? (
          <>
            <CoreUnity_After_Login SetIsLogin={SetIsLogin} SetLoadingModal={SetLoadingModal} showAlert={props.showAlert}/>
          </>
        ) : (
          <></>
        )

      }

      {
        LoadingModal_Show === true ? (
          <>
            <LoadingModal isLoading={LoadingModal_isLoading} SetLoadingModal={SetLoadingModal}/>
          </>
        ) : (
          <></>
        )
      }
    </>
  );
}

function Refferal_Component(props) {

  const { connect } = useConnect();
  const {address} = useAccount();

  const param = useParams();

  const [LoadingModal_Show, SetLoadingModal_Show] = useState(false);
  const [LoadingModal_isLoading, SetLoadingModal_IsLoading] = useState(true);
  
  const [Upline_ID, SetUpline_ID] = useState('');

  const open = async() => {
    connect({ connector: injected() });
  }
  const SetLoadingModal = async(istrue, isloading) => {
    SetLoadingModal_Show(istrue);
    SetLoadingModal_IsLoading(isloading);
  }
  
  
  useEffect(() => {
    const Check_Refferal = async() => {
      if (param.id !== '') {
        //console.log(param.id);
        SetLoadingModal(true, true);
        props.showAlert("Sponser Id is " + param.id, "success", true);
        Refferal_Detail(param.id, SetUpline_ID, open, props.showAlert, SetLoadingModal);
      }
      else {
      }      
    }
    Check_Refferal();
  }, [document.URL]);

  useEffect(() => {
    const Check_Address = async() => {
      if (address === undefined || address === "" || address === " ") {
        //console.log("Address : " + address);
      }
      else {
        //console.log("Add: " + address);
        Refferal_SignUp(address, param.id, props.showAlert, SetLoadingModal);
      }
    }
    Check_Address();
  }, [address]);

  return (
    <>
      { 
        LoadingModal_Show === true ? (
          <>
            <LoadingModal isLoading={LoadingModal_isLoading} SetLoadingModal={SetLoadingModal}/>
          </>
        ) : (
          <></>
        )
      }
    </>
  );
}

function App() {
  
  const [alert, setAlert] = useState(null);

  //-------------Alert-Area--------------------
  const showAlert = (message, type, timeout_true) => {
    setAlert({
      message: message,
      type: type,
    });

    if (timeout_true === true) {
      setTimeout(() => {
        setAlert(null);
      }, 2000);
    }
  }

  useEffect(() => {
    document.body.style.overflowX = "hidden";
  }, []);

  return (
    <div className="App" style={{overflowX: "hidden"}}>
        <Alert alert={alert}/>

        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Main_Component showAlert={showAlert}/>}></Route>
            <Route path="/r/:id" element={<Refferal_Component showAlert={showAlert}/>}></Route>
          </Routes>
        
        </BrowserRouter>
    </div>
  );
}

export default App;
